function toRecord(value: unknown): Record<string, unknown> {
  return value && typeof value === "object" ? (value as Record<string, unknown>) : {};
}

export function normalizeIsoCountryCode(value: unknown): string | undefined {
  if (typeof value !== "string") return undefined;
  const normalized = value.trim().toUpperCase();
  return /^[A-Z]{2}$/.test(normalized) ? normalized : undefined;
}

export function resolveFixedRegistrationCountryCode(...sources: unknown[]): string | undefined {
  for (const source of sources) {
    const sourceRecord = toRecord(source);
    const dataRecord = toRecord(sourceRecord.data);

    for (const record of [dataRecord, sourceRecord]) {
      const direct = normalizeIsoCountryCode(record.fixed_country_code);
      if (direct) return direct;
    }
  }

  return undefined;
}

export function findFixedCountryFiatCurrency<T extends { currency_type?: unknown; country_code?: unknown }>(
  currencies: T[],
  fixedCountryCode?: string
): T | undefined {
  const normalizedFixedCountryCode = normalizeIsoCountryCode(fixedCountryCode);
  if (!normalizedFixedCountryCode) return undefined;

  return currencies.find((currency) =>
    currency?.currency_type === "FIAT" &&
    normalizeIsoCountryCode(currency?.country_code) === normalizedFixedCountryCode
  );
}
